/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { IBasketState } from './basketReducer';
import { IBasketItem } from './basketTypes';

const makeSelectorBasket = (state: IRootReducer) => state.basket;

export const makeSelectorBasketIsLoading = 
    (): OutputSelector<IRootReducer, boolean, (state: IBasketState) => boolean> =>
    createSelector(
        makeSelectorBasket,
        (state: IBasketState) => state.isLoading,
    );
export const makeSelectorBasketList = 
    (): OutputSelector<IRootReducer, IBasketItem[], (state: IBasketState) => IBasketItem[]> =>
    createSelector(
        makeSelectorBasket,
        (state: IBasketState) => state.list,
    );
export const makeSelectorInitBasketList = 
    (): OutputSelector<IRootReducer, IBasketItem[], (state: IBasketState) => IBasketItem[]> =>
    createSelector(
        makeSelectorBasket,
        (state: IBasketState) => state.initList,
    );
